<template>
  <div>
    <div class="impact-card-list">
      <ImpactCard
        v-for="impact of impacts"
        :key="impact.key"
        :impact="impact"
      />
    </div>
  </div>
</template>

<script>

import ImpactCard from './ImpactCard.vue';

export default {
  name: 'ImpactCardGrid',
  components: {
    ImpactCard,
  },
  props: {
    impacts: {
      type: Array,
      required: true,
    },
  },
};
</script>
